import CustomerSimplifiedDTO from "features/customer/dtos/CustomerSimplifiedDTO";

export type CustomerActionTypes = "SET_CUSTOMER";

export const CustomerActionTypes = {
  SET_CUSTOMER: "SET_CUSTOMER" as CustomerActionTypes,
};

export interface SetCustomerAction {
  type: typeof CustomerActionTypes.SET_CUSTOMER;
  data: CustomerSimplifiedDTO;
}

export type CustomerActions = SetCustomerAction;

export const setCustomer = (customer: CustomerSimplifiedDTO) => {
  return {
    type: CustomerActionTypes.SET_CUSTOMER,
    data: customer
}
}
